var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none",
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.3334 0.333496C13.7934 0.333496 14.1667 0.706829 14.1667 1.16683V4.66683L18.5109 1.62516C18.6992 1.4935 18.9592 1.53933 19.0917 1.7285C19.14 1.7985 19.1667 1.88183 19.1667 1.96683V12.0335C19.1667 12.2635 18.98 12.4502 18.75 12.4502C18.6642 12.4502 18.5809 12.4235 18.5109 12.3752L14.1667 9.3335V12.8335C14.1667 13.2935 13.7934 13.6668 13.3334 13.6668H1.66671C1.20671 13.6668 0.833374 13.2935 0.833374 12.8335V1.16683C0.833374 0.706829 1.20671 0.333496 1.66671 0.333496H13.3334ZM12.5 2.00016H2.50004V12.0002H12.5V2.00016ZM17.5 4.36766L14.1667 6.701V7.29933L17.5 9.63266V4.36766Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.04bf5a78b6efe9831b573426c55bd697.svg";
export { ForwardRef as ReactComponent };